import { connect } from "react-redux";
import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import ProgressBar from "react-bootstrap/ProgressBar";
import { tableData } from "../constants/reportData";
import { getReport } from "../store/actions/userActions";
import Loading from "../components/common/Loading";
import RadarChart from "react-svg-radar-chart";
import "react-svg-radar-chart/build/css/index.css";

class Report extends Component {
  state = {
    reportData: null,
    chartData: {},
    loading: true,
  };
  componentDidMount() {
    this.props
      .getReport()
      .then((data) => {
        if (data) {
          this.setState({
            reportData: data,
            formattedData: {
              career: data.career,
              control: data.control,
              emotion: data.emotion,
              experiences: data.experiences,
              gratitude: data.gratitude,
              health: data.health,
              progress: data.progress,
              relationship: data.relationship,
            },
            loading: false,
          });
        }
      })
      .catch((e) => alert(e.message));
  }
  render() {
    const noSmoothing = (points) => {
      let d = "M" + points[0][0].toFixed(4) + "," + points[0][1].toFixed(4);
      for (let i = 1; i < points.length; i++) {
        d += "L" + points[i][0].toFixed(4) + "," + points[i][1].toFixed(4);
      }
      return d + "z";
    };
    const captions = {
      career: `Career (${
        this.state.reportData
          ? (this.state.reportData.career * 100).toFixed(0)
          : ""
      })`,
      progress: `Progress (${
        this.state.reportData
          ? (this.state.reportData.progress * 100).toFixed(0)
          : ""
      })`,
      control: `Control (${
        this.state.reportData
          ? (this.state.reportData.control * 100).toFixed(0)
          : ""
      })`,
      health: `Health (${
        this.state.reportData
          ? (this.state.reportData.health * 100).toFixed(0)
          : ""
      })`,
      gratitude: `Gratitude (${
        this.state.reportData
          ? (this.state.reportData.gratitude * 100).toFixed(0)
          : ""
      })`,
      relationship: `Relationship (${
        this.state.reportData
          ? (this.state.reportData.relationship * 100).toFixed(0)
          : ""
      })`,
      emotion: `Emotion (${
        this.state.reportData
          ? (this.state.reportData.emotion * 100).toFixed(0)
          : ""
      })`,
      experiences: `Experiences (${
        this.state.reportData
          ? (this.state.reportData.experiences * 100).toFixed(0)
          : ""
      })`,
    };

    const defaultOptions = {
      size: 100,
      axes: true, // show axes?
      scales: 5, // show scale circles?
      captions: true, // show captions?
      captionMargin: 10,
      dots: false, // show dots?
      zoomDistance: 1.2, // where on the axes are the captions?
      setViewBox: (options) =>
        `-${options.captionMargin} 0 ${
          options.size + options.captionMargin * 2
        } ${options.size}`, // custom viewBox ?
      smoothing: noSmoothing, // shape smoothing function
      axisProps: () => ({ className: "axis", stroke: "#200a24", fill: "none" }),
      scaleProps: () => ({
        className: "scale",
        stroke: "#200a24",
        fill: "none",
      }),
      shapeProps: () => ({ className: "shape" }),
      captionProps: () => ({
        className: "caption",
        // dominantBaseline: "hanging",
        fontSize: 14,
        fontFamily: "Open Sans",
      }),
      dotProps: () => ({
        className: "dot",
        mouseEnter: (dot) => {},
        mouseLeave: (dot) => {},
      }),
    };
    if (this.state.loading) return <Loading />;
    return (
      <Container
        fluid={true}
        style={{ overflowY: "scroll", width: "95%" }}
        className="mx-lg-5"
      >
        <div className="report-container overflow-auto">
          {/* <button onClick={this.printPDF}>Print</button> */}
          <div
            className="close-btn"
            onClick={this.props.close}
            style={{
              position: "absolute",
              top: "3rem",
              right: "3rem",
              color: "#808080	",
              cursor: "pointer",
            }}
          >
            <i className="fa fa-times"></i>
          </div>
          {/* <div style={{ background: "#200A24", height: "8rem" }}></div> */}
          <div
            className="report ptb--80"
            id="report"
            style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
          >
            <div className="her-score">
              <Row className="text-left">
                <Col sm={12} className="px-0">
                  <h4>HER Score</h4>
                </Col>
                {this.state.reportData && (
                  <Col>
                    <Row className="p-0 ">
                      <Col
                        className="text-left "
                        style={{
                          color: "#200a24",
                          marginLeft: `${this.state.reportData.score}%`,
                        }}
                      >
                        <p
                          className="mb-0"
                          style={{ fontSize: "1.4rem", fontWeight: "bold" }}
                        >
                          {this.state.reportData.score.toFixed(0)}
                        </p>
                        <i className="fas fa-2x fa-caret-down mb--0"></i>
                      </Col>
                    </Row>
                    <ProgressBar className="mb-lg-2">
                      <ProgressBar
                        style={{ backgroundColor: "#ff9aa2" }}
                        now={40}
                        key={1}
                      />
                      <ProgressBar
                        style={{ backgroundColor: "#fbd1b9" }}
                        now={40}
                        key={2}
                      />
                      <ProgressBar
                        style={{ backgroundColor: "#b5ead6" }}
                        now={20}
                        key={3}
                      />
                    </ProgressBar>
                    <Row className="justify-content-between p-0 m-0">
                      <p>0</p>
                      <p>100</p>
                    </Row>
                  </Col>
                )}
              </Row>
            </div>
            <div className="wheel">
              <Row className="text-left">
                <Col sm={12} className="px-0">
                  <h4 className="mt-lg-5">WHEEL OF LIFE</h4>
                </Col>
                <Col sm={12} className="text-center">
                  <RadarChart
                    captions={captions}
                    data={[
                      {
                        data: this.state.formattedData,
                        meta: { color: "#4ec8a3" },
                      },
                    ]}
                    size={680}
                    options={defaultOptions}
                  />
                </Col>
              </Row>
            </div>

            <div className="happiness">
              <Row className="text-left">
                <Col sm={12} className="px-0">
                  <h4 className="mt-lg-5">ELEMENTS OF HAPPINESS</h4>
                </Col>
              </Row>
              {this.state.reportData &&
                tableData.map((data, key) => {
                  return (
                    <Row
                      className="justify-content-center text-left my-2"
                      key={key}
                    >
                      <Col
                        lg={11}
                        xs={8}
                        className="align-items-center my-lg-2 px-0"
                      >
                        <h4 className="mb--5 subtitle">{data.title}</h4>
                      </Col>
                      <Col lg={1} xs={2} className="my-lg-2">
                        {key === 8 ? (
                          <span
                            className="scores"
                            style={{
                              backgroundColor:
                                this.state.reportData.score > 79
                                  ? "#b5ead6"
                                  : this.state.reportData.score > 39
                                  ? "#fbd1b9"
                                  : "#ff9aa2",
                            }}
                          >
                            {this.state.reportData.score.toFixed(0)}
                          </span>
                        ) : (
                          <span
                            className="scores"
                            style={{
                              backgroundColor:
                                this.state.reportData[
                                  data.title.toLowerCase()
                                ] *
                                  100 >
                                79
                                  ? "#b5ead6"
                                  : this.state.reportData[
                                      data.title.toLowerCase()
                                    ] *
                                      100 >
                                    39
                                  ? "#fbd1b9"
                                  : "#ff9aa2",
                            }}
                          >
                            {(
                              this.state.reportData[data.title.toLowerCase()] *
                              100
                            ).toFixed(0)}
                          </span>
                        )}
                      </Col>
                      <div className="content mt-lg-4 px-lg-0 px-0">
                        <p
                          className="text-justify"
                          style={{ lineHeight: "1.8rem" }}
                        >
                          {data.content}
                        </p>
                      </div>
                      <div className="table">
                        <Table responsive bordered>
                          <thead>
                            <tr>
                              <th style={{ width: "25%" }}>Score Range</th>
                              <th style={{ width: "25%" }}>Category</th>
                              <th style={{ width: "50%" }}>Interpretation</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>80-100</td>
                              <td
                                className="high"
                                style={{ backgroundColor: "#b5ead6" }}
                              >
                                High
                              </td>
                              <td className="text-justify">
                                {data.tableContent[0]}
                              </td>
                            </tr>
                            <tr>
                              <td>40-79</td>
                              <td
                                className="med"
                                style={{ backgroundColor: "#fbd1b9" }}
                              >
                                Medium
                              </td>
                              <td>{data.tableContent[1]}</td>
                            </tr>
                            <tr>
                              <td>0-39</td>
                              <td
                                className="low"
                                style={{ backgroundColor: "#ff9aa2" }}
                              >
                                Low
                              </td>
                              <td className="text-justify">
                                {data.tableContent[2]}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </Row>
                  );
                })}
            </div>
          </div>
        </div>
      </Container>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReport: () => dispatch(getReport()),
  };
};
export default connect(null, mapDispatchToProps)(Report);
